import type { IconAsset } from '../Icon.types';

export const plus: IconAsset = {
  bold: {
    l: {
      code: (
        <path
          clipRule='evenodd'
          d='M10.5003 13.5302V20H13.5003V13.5302L20 13.5302V10.5302L13.5002 10.5302V4H10.5002V10.5302L4 10.5302V13.5302L10.5003 13.5302Z'
          fill='currentColor'
          fillRule='evenodd'
        />
      ),
    },
    m: {
      code: (
        <path
          clipRule='evenodd'
          d='M11.5 3H8.5V8.5H3L3 11.5H8.5V17H11.5V11.5H17V8.5H11.5V3Z'
          fill='currentColor'
          fillRule='evenodd'
        />
      ),
    },
    s: {
      code: (
        <path
          clipRule='evenodd'
          d='M9.5 2H6.5V6.5H2L2 9.5H6.5V14H9.5V9.5H14V6.5H9.5V2Z'
          fill='currentColor'
          fillRule='evenodd'
        />
      ),
    },
  },
  regular: {
    l: {
      code: (
        <path
          clipRule='evenodd'
          d='M13 4H11V11H4V13H11V20H13V13H20V11H13V4Z'
          fill='currentColor'
          fillRule='evenodd'
        />
      ),
    },
    m: {
      code: (
        <path
          clipRule='evenodd'
          d='M11 3H9V9H3V11H9V17H11V11H17V9H11V3Z'
          fill='currentColor'
          fillRule='evenodd'
        />
      ),
    },
    s: {
      code: (
        <path
          clipRule='evenodd'
          d='M9 2H7V7H2V9H7V14H9V9H14V7H9V2Z'
          fill='currentColor'
          fillRule='evenodd'
        />
      ),
    },
  },
};
